class SeoSection{
	constructor() {

		if($('.sectionSeo').length === 0){
			return;
		}

		this.content = document.querySelectorAll('.sectionSeo .boxed')
		this.firstPart = []
		this.secondPart = []
		this.thirdPart = []

		this.contentArray =[this.firstPart,this.secondPart,this.thirdPart]
		this.sectionClass = ['seoFirst','seoSecond','seoThird'];
		this.seoBtn = document.querySelectorAll('.seoList li')
		this.init()
	}

	init(){

		for (let i = 0; i<=3;i++){
			this.firstPart.push(this.content[0].children[i])
		}
		for (let i = 4; i<8;i++){
			this.secondPart.push(this.content[0].children[i])
		}
		for (let i = 8; i<this.content[0].children.length;i++){
			this.thirdPart.push(this.content[0].children[i])
		}
		this.content[0].innerHTML = ""

		for (let i = 0; i<3;i++){
			let section = document.createElement('div')
			section.className = this.sectionClass[i]
			section.className += ' seoContent'
			this.content[0].append(section)
		}

		let seoContent = document.querySelectorAll('.seoContent')

		seoContent[0].classList.add('active-seo');

		this.contentArray.forEach((e,i)=>{
			e.forEach(z=>{
				seoContent[i].append(z)
			})
		})


		this.seoBtn.forEach((e,i)=>{
			e.addEventListener('click',()=>{
				[].forEach.call(seoContent,(el)=>{
					el.classList.remove('active-seo')
				})
				seoContent[i].classList.add('active-seo')
			})
		})


	}
}

module.exports = SeoSection;
